module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "u-relative u-fit"
  }, [_c('div', {
    staticClass: "c-home-slide--1__main-container u-relative u-flex u-flex-ai--center u-fit"
  }, [_c('div', {
    staticClass: "c-home-slide--1__main-container__informations u-absolute u-zindex--2 u-flex u-flex-ai--center u-flex-jc--center u-fit t-ffamily--simplon",
    class: [_vm.hoverInformationsHidden ? 'is-hidden' : '']
  }, [_c('div', {
    staticClass: "c-home-slide__element has-delay-0"
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "c-home-slide--1__main-container__informations-circle u-absolute"
  }, [_c('svg', {
    staticClass: "u-absolute u-pos-tl u-fit"
  }, [_c('circle', {
    attrs: {
      "cx": "50%",
      "cy": "50%",
      "r": "49%",
      "stroke": "#ffffff",
      "stroke-width": "5",
      "stroke-opacity": "0.2",
      "fill": "none"
    }
  })]), _vm._v(" "), _c('svg', {
    staticClass: "u-absolute u-pos-tl u-fit"
  }, [_c('circle', {
    staticClass: "c-home-slide--1__main-container__informations-circle-fill",
    attrs: {
      "cx": "50%",
      "cy": "50%",
      "r": "49%",
      "stroke": "#ffffff",
      "stroke-width": "5",
      "stroke-opacity": "0.8",
      "fill": "none"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "c-home-slide--1__filter c-home-slide__element has-delay-0 u-absolute u-pos-tl u-fit-w"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-home-slide--1__container  u-relative u-zindex--1 u-flex u-flex-ai--center u-fit u-align-center"
  }, [_c('div', {
    staticClass: "c-home-slide__element has-delay-0"
  }, [_c('div', {
    staticClass: "c-home-slide--1__container__prac-earned-container u-absolute u-flex u-flex-ai--stretch u-flex-jc--center t-ffamily--simplon"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "c-home-slide--1__container__prac-earned-container__text t-fweight--light u-color--white"
  }, [_vm._v("\n                        " + _vm._s(_vm.pracEarnedString) + "\n\n                        "), _c('app-icon', {
    staticClass: "u-fill--white u-stroke--white u-opacity--60",
    attrs: {
      "name": "icon-logotype--stroked",
      "width": "15px"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "c-home-slide--1__container__wrapper u-marg-x-auto u-w6of12"
  }, [_c('div', {
    staticClass: "c-home-slide__element has-delay-0"
  }, [_c('app-home-slide-nb-title', {
    attrs: {
      "number": "02",
      "index": 2,
      "label": "Spatial Mining",
      "color": "white"
    }
  })], 1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "c-home-slide__element has-delay-3"
  }, [_c('div', {
    staticClass: "c-home-slide--1__container__wrapper__button js-home-slide-1-button u-relative u-marg-x-auto u-cursor-pointer",
    on: {
      "click": function($event) {
        _vm._onClickOnButton()
      },
      "mouseenter": function($event) {
        _vm._onMouseenterButton()
      },
      "mouseleave": function($event) {
        _vm._onMouseleaveButton()
      }
    }
  }, [_c('div', {
    staticClass: "c-home-slide--1__container__wrapper__button__hexagon-blue u-absolute u-pos-center u-fit u-bg--brand-primary"
  }), _vm._v(" "), _c('app-icon', {
    staticClass: "c-home-slide--1__container__wrapper__button__icon u-absolute u-pos-center u-fill--white u-stroke--white",
    attrs: {
      "name": "icon-headset",
      "width": "34px"
    }
  })], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "u-color--white u-uppercase"
  }, [_vm._v("Hover to map the area and collect PRAX")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-home-slide--1__container__prac-earned-container__left u-relative t-fweight--medium t-fsize--xs u-uppercase u-color--white"
  }, [_vm._v("\n                        Earned\n\n                        "), _c('div', {
    staticClass: "c-home-slide--1__container__prac-earned-container__left__line u-absolute  u-fit-w u-bg--white-o20"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "c-home-slide--1__container__wrapper__title u-relative t-fweight--light u-color--white u-lheight--125p"
  }, [_c('div', {
    staticClass: "c-home-slide--1__container__wrapper__title--1  c-home-slide__element has-delay-1 u-relative"
  }, [_vm._v("3D World = 3D Maps")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-home-slide--1__container__wrapper__description  o-content u-relative u-marg-x-auto u-w1of2 u-lheight--150p u-color--gray-lighter u-force-3d"
  }, [_c('p', {
    staticClass: " c-home-slide__element has-delay-2"
  }, [_c('span', {
    staticClass: "u-opacity--60"
  }, [_vm._v("Mapping the world is not an easy task. It starts with people like us, out in the world, scanning in the places we visit the most. As incentives grow, more will join us,  and we will create a whole new dimension on top of this reality.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ee02910"}!./src/scripts/components/app-home-slide-1/template.html
// module id = 455
// module chunks = 0